import styled from '@emotion/styled';

const ContactEl = styled.li`
  div {
    display: flex;
    align-items: center;
  }

  p {
    margin: 0;

    font-weight: 400;
    font-size: 18px;
    line-height: 1.19;
    letter-spacing: 0.03em;
  }

  button {
    padding: 5px 15px;
    margin-left: auto;
  }
`;

export { ContactEl };
